import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Actions as NOTIFICATION_ACTIONS } from "../../store/actions/notificationActions";
import { NotificationIcons as icons } from "./NotificationIcons";

const NotificationRow = ({ id, type, description, title, read, getNotification, directTo }) => {
	const Icon = icons[type];
	return (
		<>
			<div
				style={{
					borderRadius: "2rem",
					marginBottom: "0.5rem",
					padding: "1rem",
					background: read ? "white" : "rgba(234, 97, 28, 0.1)",
					border: read ? "solid rgba(234, 97, 28, 0.1) 2px" : "none",
				}}
			>
				<div className="col-xs-2">
					{Icon ? (
						<div style={{ padding: "0.5rem" }}>
							<Icon style={{ height: "3rem" }} />
						</div>
					) : null}
				</div>
				<div
					className="col-xs-7"
					style={{ color: "rgb(35, 42, 50)" }}
				>
					<h4>{title}</h4>
					<p style={{ marginBottom: 0, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
						{description}
					</p>
				</div>
				<div
					className="col-xs-3"
					style={{ paddingTop: "0.5rem" }}
				>
					{id ? (
						<Link
							to={`/notifications/${id}`}
							className="btn btn-primary pull-right"
							onClick={() => {
								getNotification(id);
							}}
						>
							View
						</Link>
					) : null}
					{directTo ? (
						<Link
							to={directTo?.link}
							className="btn btn-primary pull-right"
						>
							{directTo?.text || "View"}
						</Link>
					) : null}
				</div>
				<div className="clearfix" />
			</div>
		</>
	);
};

const mapStateToProps = (state, ownProps) => {
	const { type, description, title, source, read, id, directTo } = { ...ownProps.notification };

	return { type, description, title, source, read, id, directTo };
};

const mapDispatchToProps = (dispatch) => ({
	getNotification: (id) => dispatch(NOTIFICATION_ACTIONS.getNotification(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationRow);
